/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BodyConstitutionChanges {
    WEIGHT_GAIN = 'weightGain',
    WEIGHT_LOSS = 'weightLoss',
    NO_CHANGES = 'noChanges',
}
